import { useConnectorsMap } from '#pplx/frontend/apps/ask/connectors/hooks/useConnectorsMap.js';
import { useMemo } from 'react';
/**
 * Hook that returns functions to check connector availability and connection status.
 * This respects the same backend logic that gates connector access in the settings page.
 *
 * @returns An object with three functions:
 *   - isAllowed: checks if a connector is available to the user
 *   - isConnected: checks if a connector is both available and connected
 *   - getConnectionType: returns the connection type for a connector
 */
export const useConnectorStatus = ({ reason, enabled = true, }) => {
    const { connectorsMap } = useConnectorsMap({ reason, enabled });
    return useMemo(() => {
        return {
            isAllowed: (connectorId) => !!connectorsMap[connectorId],
            isConnected: (connectorId) => connectorsMap[connectorId]?.connected === true,
            getConnectionType: (connectorId) => connectorsMap[connectorId]?.connection_type ?? null,
        };
    }, [connectorsMap]);
};
//# sourceMappingURL=useConnectorStatus.js.map